import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { downgradeComponent } from '@angular/upgrade/static';

import { SharedModule } from '../../shared';

/* User Configuration entry components */
import { ChangePasswordComponent } from './change-password/change-password.component';
import { EmailNotificationSettingsComponent } from './notification-settings/email-notification-settings.component';

import { PasswordApiService } from './change-password/password-api.service';
import { PasswordStrengthComponent } from './change-password/password-strength/password-strength.component';


/*
   This page has angular.js components in between serverside rendered html.
   We are not wrapping each one in an Angular UpgradeComponent because it would
   be cumbersome and give us no benefit. They are small and independent enough
   to instead be rewritten directly into Angular components, and then added
   to the below module.

   Contrary to the hybrid pages with single entrypoints, this module does
   not get lazily-loaded. We instead import it into the RootAppModule.

   c.f. site-configuration.app.module, cloud-configuration.app.module, account-configuration.app.module
*/

const userConfigurationComponents = [
   ChangePasswordComponent,
   PasswordStrengthComponent,
   EmailNotificationSettingsComponent,
];

@NgModule({
   declarations: userConfigurationComponents,
   imports: [
      CommonModule,
      ReactiveFormsModule,
      SharedModule,
   ],
   providers: [
      PasswordApiService,
   ],
   exports: userConfigurationComponents,
})
export class UserConfigurationAppModule {}

export const UserConfigurationAjsModule = angular.module('hybd.user.configuration', []);

UserConfigurationAjsModule
   .directive('bbChangePassword', downgradeComponent({component: ChangePasswordComponent}))
   .directive('bbEmailNotificationSettings', downgradeComponent({component: EmailNotificationSettingsComponent}));
